export default __webpack_public_path__ + "static/media/job3.46ae5ce3.svg";